import { WithChildrenCommonProps } from '@shipengine/giger';
import { getShipmentRowExtensionStyles } from './ShipmentRowExtensionStyles';

export function ShipmentRowExtension({ children }: WithChildrenCommonProps<unknown>): JSX.Element {
    return <section css={getShipmentRowExtensionStyles}>{children}</section>;
}
